// SaiKrishna 11/10/2022 3225733165 Fixed work queue back and front icons bugs with functionality
// akhila 12/3/2022 3225733165 Fixed work queue back issue.
// dilip 12/5/2022 3225733165 Removed unnecessary console.log statements
// dilip 01/03/2023 3225733165 Changed the work queue forward functionality to show the warning popup.
// dilip 01/03/2023 3225733165 Removing account number from work queue.
// Rohini 01/03/2023 3225733165 fixed the alignment issue in button in nav section.
// dilip 01/26/2023 3225733165 Add lock account check functionality
// dilip 01/31/2023 3225733165 Split work queue functionality
// dilip 03/01/2023 3225733165 Fixed account remove functionality
// dilip 06/12/2023 3225733165 Fixed popup issue

import LockAlert from './LockAlert';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import WorkQueueDialog from './WQWarning';
import { ArrowBack } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Box, Tooltip, Button } from '@material-ui/core';
import ForwardIcon from '@material-ui/icons/ArrowForward';
import { SPLIT_SCREEN } from '../../constants/WorkQueueConstants';
import { setShowDashboardWorkQueue } from '../../redux/reducers/role';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

import {
  changeWorkQueueSession,
  getNextAccountData,
  getPreviousAccountData,
  getWorkQueueListData,
  resetAccountExistsInfo,
  resetNextAccountData,
} from '../../redux/reducers/WorkQueueList';
import { getLastAccountData } from '../../util/WorkQueues';

const HeaderForwardBackward = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [secondAccountNumber, setSecondAccountNumber] = useState(0);
  const [open, setOpen] = useState(false);
  const [lockAlertOpen, setLockAlertOpen] = useState(false);

  const { showDashboardWorkQueue } = useSelector(({ role }) => role);
  const { workQueueNextAccount, updateSession } = changeWorkQueueSession();
  const accountNumber = location?.state?.accountNumber ? location.state.accountNumber : '';
  const accNo = location?.state?.accNo ? location.state.accNo : '';
  const currentAccNo = location?.state?.currentAccNo;
  const { nextAccountData, previousAccountData, workQueueListData, accountExistsInfo } =
    useSelector(({ workQueueList }) => workQueueList);

  // IF WE START THE COMPONENT MULTIPLE TIMES THEN THIS WILL CALL THE SERVER MULTIPLE TIMES.
  useEffect(() => {
    if (workQueueNextAccount?.payload) {
      dispatch(getWorkQueueListData(workQueueNextAccount?.payload));
    }
  }, []);

  useEffect(() => {
    if (!workQueueListData?.resultObject || secondAccountNumber !== 0) return;

    const list = workQueueListData.resultObject;
    const accountNo = list && list[1]?.account_number;

    setSecondAccountNumber(accountNo);
  }, [workQueueListData, secondAccountNumber]);

  useEffect(() => {
    if (nextAccountData) {
      if (nextAccountData?.isLock) {
        history.push({
          pathname: `/account-summary`,
          state: {
            accNum: nextAccountData?.nextAccountNumber,
          },
        });
        setLockAlertOpen(true);
      } else if (nextAccountData?.nextAccountNumber) {
        history.push({
          pathname: `/account-summary`,
          state: {
            accountNumber: nextAccountData?.nextAccountNumber,
          },
        });
      } else if (nextAccountData?.nextAccountNumber === 0) {
        setOpen(true);
      }
    }
  }, [nextAccountData]);

  useEffect(() => {
    if (previousAccountData) {
      if (previousAccountData?.isLock) {
        history.push({
          pathname: `/account-summary`,
          state: {
            accNum: previousAccountData?.nextAccountNumber,
          },
        });
        setLockAlertOpen(true);
      } else if (previousAccountData?.nextAccountNumber) {
        history.push({
          pathname: `/account-summary`,
          state: {
            accountNumber: previousAccountData?.nextAccountNumber,
          },
        });
      } else if (previousAccountData?.nextAccountNumber === 0) {
        setOpen(true);
      }
    }
  }, [previousAccountData]);

  useEffect(() => {
    if (accountExistsInfo) {
      if (accountExistsInfo?.isPresent) {
        if (accountExistsInfo?.accountSummaryModifiedResponse?.accountStatus) {
          setLockAlertOpen(true);
        } else {
          history.push({
            pathname: `/account-summary`,
            state: {
              accountNumber: accountExistsInfo?.accountNumber,
            },
          });
        }
      } else if (!accountExistsInfo?.isPresent) {
        setLockAlertOpen(true);
      }
    }
  }, [accountExistsInfo]);

  const handleClose = () => {
    if (!accountExistsInfo?.isPresent) {
      if (workQueueNextAccount?.payload) {
        dispatch(getWorkQueueListData(workQueueNextAccount?.payload));
      }
    }

    setOpen(false);
    setLockAlertOpen(false);
    dispatch(resetNextAccountData());
    dispatch(resetAccountExistsInfo());
  };

  const handlePageChangeOnLastAccount = () => {
    const lastPage = Math.ceil(workQueueListData?.count / workQueueListData?.limit);
    const list = workQueueListData?.resultObject;
    const accountNo = list && list[list.length - 1]?.account_number;
    const possibleAccountNumbers = [accNo, accountNumber, location.state.accNum];

    if (possibleAccountNumbers.includes(accountNo) && !(lastPage === workQueueListData?.page)) {
      const payload = {
        ...workQueueNextAccount?.payload,
        page: workQueueNextAccount?.payload?.page + 1,
      };
      updateSession({ ...workQueueNextAccount, payload });
    }
  };

  const handlePageChangeOnFirstAccount = () => {
    const firstPage = 1;
    const list = workQueueListData?.resultObject;
    const accountNo = list && list[0]?.account_number;
    const possibleAccountNumbers = [accNo, accountNumber, location.state.accNum];
    if (possibleAccountNumbers.includes(accountNo) && !firstPage) {
      const payload = {
        ...workQueueNextAccount?.payload,
        page: workQueueNextAccount?.payload?.page - 1,
      };
      updateSession({ ...workQueueNextAccount, payload });
    }
  };

  const handleForward = () => {
    if (SPLIT_SCREEN.SHOW_SPLIT_SCREEN === showDashboardWorkQueue) {
      handlePageChangeOnLastAccount();
    }

    setLockAlertOpen(false);

    if (nextAccountData?.nextAccountNumber) {
      dispatch(
        getNextAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: nextAccountData?.nextAccountNumber,
        }),
      );
    } else {
      dispatch(
        getNextAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: accountNumber || currentAccNo || 0,
        }),
      );
    }
  };

  const handleBackward = () => {
    if (SPLIT_SCREEN.SHOW_SPLIT_SCREEN === showDashboardWorkQueue) {
      handlePageChangeOnFirstAccount();
    }

    setLockAlertOpen(false);
    if (previousAccountData?.nextAccountNumber) {
      dispatch(
        getPreviousAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: previousAccountData?.nextAccountNumber,
        }),
      );
    } else {
      dispatch(
        getPreviousAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: accountNumber || currentAccNo || 0,
        }),
      );
    }
  };

  const handleFirstPage = async () => {
    if (SPLIT_SCREEN.SHOW_SPLIT_SCREEN !== showDashboardWorkQueue) {
      return;
    }

    const firstPage = 1;
    workQueueNextAccount.payload.page = firstPage;

    const payload = {
      ...workQueueNextAccount?.payload,
      page: firstPage,
    };
    updateSession({ ...workQueueNextAccount, payload });

    dispatch(
      getPreviousAccountData({
        ...workQueueNextAccount[showDashboardWorkQueue],
        accountNumber: secondAccountNumber,
      }),
    );
  };

  const handleLastPage = async () => {
    if (SPLIT_SCREEN.SHOW_SPLIT_SCREEN !== showDashboardWorkQueue) {
      return;
    }

    const lastPage = Math.ceil(workQueueListData?.count / workQueueListData?.limit);
    workQueueNextAccount.payload.page = lastPage;

    const payload = {
      ...workQueueNextAccount?.payload,
      page: lastPage,
    };
    updateSession({ ...workQueueNextAccount, payload });

    try {
      // Wait for getLastAccountData to resolve
      const { lastAccountNumber } = await getLastAccountData({
        ...workQueueNextAccount[showDashboardWorkQueue],
      });

      // Wait for the previous account data dispatch to resolve
      const previousAccountData = await dispatch(
        getPreviousAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: lastAccountNumber,
        }),
      );

      // Once the previous account data is fetched, dispatch getNextAccountData
      await dispatch(
        getNextAccountData({
          ...workQueueNextAccount[showDashboardWorkQueue],
          accountNumber: previousAccountData?.nextAccountNumber,
        }),
      );
    } catch (error) {
      console.error('Error fetching account data:', error);
    }
  };

  useEffect(
    () => () => {
      dispatch(setShowDashboardWorkQueue(''));
      dispatch(resetNextAccountData());
      dispatch(resetAccountExistsInfo());
    },
    [],
  );

  window.onbeforeunload = function (e) {
    sessionStorage.removeItem('workQueueNextAccount');
  };

  const {
    workQueueNextAccount: { workQueueRowData },
  } = changeWorkQueueSession();

  return (
    <Box className="d-flex align-items-center">
      {<WorkQueueDialog open={open} handleClose={handleClose} />}
      {lockAlertOpen && (
        <LockAlert
          open={lockAlertOpen}
          handleClose={handleClose}
          handleForward={() => {
            handleForward();
          }}
          lockAlertCondition={accountExistsInfo?.isPresent}
          accNo={accNo || nextAccountData?.nextAccountNumber}
        />
      )}
      <>
        <div className="account-backward-sec">
          <Tooltip title="Go to first account in the Work Queue" interactive className="mr-2">
            <Button variant="contained" color="primary" onClick={handleFirstPage}>
              <DoubleArrowIcon
                style={{
                  cursor: 'pointer',
                  transform: 'rotate(180deg)',
                }}
              />
            </Button>
          </Tooltip>
          <Tooltip
            title={workQueueRowData?.workqueueName ? workQueueRowData?.workqueueName : ''}
            interactive
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleBackward();
              }}
            >
              <ArrowBack className="mr-2" />
              Previous Account
            </Button>
          </Tooltip>
        </div>
      </>
      <>
        <div className="account-backward-sec ml-2">
          <Tooltip
            title={workQueueRowData?.workqueueName ? workQueueRowData?.workqueueName : ''}
            interactive
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleForward();
              }}
            >
              Next Account
              <ForwardIcon
                className="ml-2"
                style={{
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Tooltip>
          <Tooltip title="Go to the last account in the Work Queue" interactive className="ml-2">
            <Button variant="contained" color="primary" onClick={handleLastPage}>
              <DoubleArrowIcon
                style={{
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Tooltip>
        </div>
      </>
    </Box>
  );
};

export default HeaderForwardBackward;
